import React, { useState } from 'react';
import { Breadcrumb } from '../components/common/Breadcrumb';
import { FileUploader } from '../components/potential/FileUploader';
import { UploadResults } from '../components/potential/UploadResults';
import { PotentialFilters } from '../components/potential/PotentialFilters';
import { PotentialTable } from '../components/potential/PotentialTable';
const breadcrumbItems = [{
  label: 'Financiación',
  href: '#'
}, {
  label: 'Usuarios Potenciales'
}];
export const PotentialUsers = () => {
  const [uploadResults, setUploadResults] = useState(null);
  const [showResults, setShowResults] = useState(false);
  const handleUploadComplete = results => {
    setUploadResults(results);
    setShowResults(true);
  };
  const handleCloseResults = () => {
    setShowResults(false);
  };
  return <div className="min-h-screen bg-gray-50" data-id="element-1470">
      <main className="pt-16 pl-64" data-id="element-1471">
        <div className="max-w-7xl mx-auto p-8" data-id="element-1472">
          <div className="mb-8" data-id="element-1473">
            <Breadcrumb items={breadcrumbItems} data-id="element-1474" />
            <h1 className="text-2xl font-bold text-gray-900 mt-4" data-id="element-1475">
              Gestión de Usuarios Potenciales
            </h1>
          </div>
          <div className="bg-white rounded-lg shadow p-6 mb-8" data-id="element-1476">
            <h2 className="text-lg font-medium text-gray-900 mb-4" data-id="element-1477">
              Carga Masiva de Usuarios
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-1478">
              Suba un archivo CSV o TXT con los datos de usuarios potenciales
              para financiación. El archivo debe contener las columnas: nombre,
              identificación, correo, teléfono y monto solicitado.
            </p>
            <FileUploader onUploadComplete={handleUploadComplete} data-id="element-1479" />
          </div>
          {showResults && <UploadResults results={uploadResults} onClose={handleCloseResults} data-id="element-1480" />}
          <div className="mt-12" data-id="element-1481">
            <h2 className="text-lg font-medium text-gray-900 mb-6" data-id="element-1482">
              Usuarios Potenciales
            </h2>
            <PotentialFilters data-id="element-1483" />
            <PotentialTable data-id="element-1484" />
          </div>
        </div>
      </main>
    </div>;
};